/**
 * 车辆基础信息数据
 */
export const vehicleList = [
    {
        vno: "鲁Q00005",
        vco: "2",
        gpsSpeed: "2.9",
        gpsStatus: "2",
        accStatus: "2",
        utc: "1678167375000",
        lat: "26.8075746",
        lon: "112.5979179",
        head: "29"
    },
    {
        vno: "鲁H00001",
        vco: "2",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1676875487000",
        lat: "39.9714158",
        lon: "116.3621002",
        head: "0"
    },
    {
        vno: "鲁H00002",
        vco: "1",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1672814375000",
        lat: "40.0459317",
        lon: "116.2942291",
        head: "0"
    },
    {
        vno: "鲁H00003",
        vco: "1",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1669714107000",
        lat: "35.6446924",
        lon: "112.7538137",
        head: "30"
    },
    {
        vno: "鲁H00004",
        vco: "5",
        gpsSpeed: "61.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1669712611000",
        lat: "35.56348",
        lon: "112.7161807",
        head: "30"
    },
    {
        vno: "鲁H00005",
        vco: "1",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1669710506000",
        lat: "35.5974468",
        lon: "112.9573398",
        head: "30"
    },
    {
        vno: "鲁H00006",
        vco: "5",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1669710362000",
        lat: "35.6693716",
        lon: "112.7909913",
        head: "30"
    },
    {
        vno: "鲁H00007",
        vco: "5",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1669711040000",
        lat: "35.3763975",
        lon: "112.7594964",
        head: "30"
    },
    {
        vno: "鲁H00008",
        vco: "2",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1667811303000",
        lat: "35.826995",
        lon: "111.5965858",
        head: "30"
    },
    {
        vno: "鲁H00009",
        vco: "5",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1667800402000",
        lat: "35.7831398",
        lon: "111.4649016",
        head: "30"
    },
    {
        vno: "鲁H00010",
        vco: "3",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1659425844000",
        lat: "41.0348158",
        lon: "114.7347668",
        head: "30"
    },
    {
        vno: "鲁H00011",
        vco: "3",
        gpsSpeed: "0.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1656655327000",
        lat: "39.9794158",
        lon: "116.3521002",
        head: "30"
    },
    {
        vno: "鲁H00012",
        vco: "1",
        gpsSpeed: "80.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1657614467000",
        lat: "26.6782555",
        lon: "106.6253434",
        head: "30"
    },
    {
        vno: "鲁H00013",
        vco: "2",
        gpsSpeed: "60.0",
        gpsStatus: "1",
        accStatus: "1",
        utc: "1656655327000",
        lat: "39.9694158",
        lon: "116.3521002",
        head: "30"
    }
];